export default __webpack_public_path__ + "static/media/bg-popcorn.5931534c.jpg";